module.exports = __webpack_public_path__ + "img/bus.9457ba09.gif";